import { useGetActionUpdateAuditById } from 'src/hooks/queries/action-update-audit/useGetActionUpdateAuditById';

import { getAuditItems } from './auditEntityFinder';
import AuditViewComponent from './AuditViewComponent';
import type { AuditEntityRetrieverInput } from './types';

const ActionUpdateAudit = (input: AuditEntityRetrieverInput) => {
  const { data: result } = useGetActionUpdateAuditById({
    queryArgs: { id: input.id },
  });
  const { current, previous } = getAuditItems(
    result?.action_update_audit,
    input.operationDate
  );

  return (
    <AuditViewComponent
      operation={input.operation}
      current={JSON.stringify(current, null, 2)}
      previous={JSON.stringify(previous, null, 2)}
    />
  );
};

export default ActionUpdateAudit;
